module.exports = __webpack_public_path__ + "img/H000140_apple.f989dc41.png";